/**
 * maximum category number attached to an advert
 * @type {number}
 */
export const CATEGORY_LIMIT = 10;

/**
 *
 * @type {{desktop: number, mobile: number}}
 */
export const CATEGORIES_DEFAULT_DISPLAY = {
    mobile: 1,
    desktop: 3,
};

const letterRange = 'a-zA-Z_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F\u1E00-\u1EFF';
const precedingChar = '^|[\\s\\b.?!;/]';
const letter = `[${letterRange}]`;
const hashtag = '[#\uFF03]';
const trailingChar = `[${letterRange}0-9]`;
const postChar = `$|[^${letterRange}0-9]`;

/**
 * Regex permettant d'extraire les hashtags du texte.
 *
 * @type {RegExp}
 */
export const tagRecognitionRegex = new RegExp(
    `(?:${precedingChar})(${hashtag}(?:\\d${letter}|${letter}\\d|${letter}{2})${trailingChar}*)(?=${postChar})`,
    'gm',
);
/*
 lookbehind <=? not supported in Safari,
 match now capture preceding char of hashtag.
 new spliter below used to recognize
*/

/**
 * Regex permettant d'extraire les hashtags du texte.
 *
 * @type {RegExp}
 */
export const tagSpliterRegex = new RegExp(
    `(${hashtag}(?:\\d${letter}|${letter}\\d|${letter}{2})${trailingChar}*)(?=${postChar})`,
    'gm',
);


